import { get } from '../request';

export async function fetchAppraiserStatus(
  { equityfinderService },
  authenticationToken,
  { year },
) {
  const url = `${equityfinderService}/equityfinder/visualization/appraiserequitystats/${year}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraisers({ userService }, authenticationToken) {
  const url = `${userService}/trueprodigy/appraiser`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchRecentEdits(
  { equityfinderService },
  authenticationToken,
  { userEmail },
) {
  let url = `${equityfinderService}/equityfinder/visualization/recentedits`;
  if (userEmail) {
    url += `?userEmail=${userEmail}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchHotList(
  { equityfinderService },
  authenticationToken,
  { appraiserCode, supervisorCode },
) {
  let url = `${equityfinderService}/equityfinder/visualization/protestlisting`;
  if (appraiserCode) {
    url += `?appraiserCode=${appraiserCode}`;
  } else if (supervisorCode) {
    url += `?supervisor=${supervisorCode}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchProtest(
  { equityfinderService },
  authenticationToken,
  { appraiserCode, supervisorCode, year },
) {
  let url = `${equityfinderService}/equityfinder/visualization/proteststats/${year}`;
  if (appraiserCode) {
    url += `?appraiserCode=${appraiserCode}`;
  } else if (supervisorCode) {
    url += `?supervisor=${supervisorCode}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTimeLines(
  { equityfinderService },
  authenticationToken,
  { appraiserCode, supervisorCode },
) {
  let url = `${equityfinderService}/equityfinder/visualization/timeline`;
  if (appraiserCode) {
    url += `?appraiserCode=${appraiserCode}`;
  } else if (supervisorCode) {
    url += `?supervisor=${supervisorCode}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTimeLine(
  { equityfinderService },
  authenticationToken,
  { week, appraiserCode, supervisorCode, statusCd },
) {
  let url = `${equityfinderService}/equityfinder/visualization/timelinelisting/${week}`;
  if (appraiserCode) {
    url += `?appraiserCode=${appraiserCode}`;
  } else if (supervisorCode) {
    url += `?supervisor=${supervisorCode}`;
  }
  if (statusCd) {
    if (appraiserCode) {
      url += '&';
    } else {
      url += '?';
    }
    url += `statusCd=${statusCd}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraiserCase(
  { equityfinderService },
  authenticationToken,
  { appraiserCode, casePrepared, year },
) {
  let url = `${equityfinderService}/equityfinder/visualization/appraiserequitycase/${year}`;
  if (appraiserCode) {
    url += `?appraiser=${appraiserCode}`;
  }
  if (casePrepared) {
    if (appraiserCode) {
      url += '&';
    } else {
      url += '?';
    }
    url += `casePrepared=${casePrepared}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchEvidence(
  { equityfinderService },
  authenticationToken,
  { appraiserCode, supervisorCode },
) {
  let url = `${equityfinderService}/equityfinder/visualization/14dayevidence`;
  if (appraiserCode) {
    url += `?appraiserCode=${appraiserCode}`;
  } else if (supervisorCode) {
    url += `?supervisor=${supervisorCode}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}
